import React from "react";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  label: {
    // backgroundColor: "red", // debugging
    display: "block",
    height: "100%",
    boxSizing: "content-box",
    textAlign: "center",
  },
  textField: {
    width: 36,
    paddingTop: 12,
    paddingBottom: 12,
    // "& input": {
    // 	border: 0,
    // },
  },
});

const SingleText = ({
  t1,
  selectionsRefs,
  cursorX,
  cursorY,
  form,
  lastAction,
  computeStake,
}) => {
  const classes = useStyles();
  return (
    <label className={classes.label}>
      <TextField
        onInput={(e) => {
          if (e.target.value === "r") e.target.value = "r";
          else
            e.target.value = Math.max(0, parseInt(e.target.value))
              .toString()
              .slice(0, 1);
        }}
        onKeyPress={() => {
          // let pos = cursorY * 4 + cursorX;
          let pos = cursorY * 5 + cursorX;
          // let posNext = (pos + 1) % (4 * (cursorY + 1));
          let posNext = pos + 1;
          let big = (posNext % 4) - cursorY;

          // 0    1    2    3
          // 0 0, 0 1, 0 2, 0 3,
          // 4

          // 5    6    7    8
          // 1 0, 1 1, 1 2, 1 3,
          // 9

          // 10   11   12   13
          // 2 0, 2 1, 2 2, 2 3,
          // 14

          // console.log(cursorY);
          // console.log(cursorX);
          // console.log(posNext);
          let next;
          if (big !== 0) {
            next =
              selectionsRefs.current[posNext].children[0].getElementsByTagName(
                "input"
              )[0];
          } else {
            next = selectionsRefs.current[posNext];
          }

          setTimeout(() => {
            next.focus();
            next.select();
          }, 125);
        }}
        type="number"
        className={classes.textField}
        ref={t1}
        onChange={(e) => {
          let board = [...form.values.board];
          board[cursorY].betSlip[cursorX] = e.target.value;
          form.setFieldValue("board", board);
          //
          let v = {
            ...form.values,
            board: board,
          };
          if (lastAction) lastAction(v);
          computeStake(form);
        }}
        value={form.values.board[cursorY].betSlip[cursorX]}
        placeholder={form.values.betType === "4D Roll" ? "R" : ""}
      />
    </label>
  );
};

export default SingleText;
